import { forwardRef, ReactElement, Ref } from "react";
import { EditGenericWithDestinationWindowTile, EditGenericWithDestinationWindowTilePropsBase } from "./EditGenericWithDestinationWindowTile";
import { EditTileHandle } from "./EditTile";
import { TeamsDetailsTileModel, updateTeamsTile } from "client/Api/Workspace/workspace";

export type EditTeamsTileProps = EditGenericWithDestinationWindowTilePropsBase<TeamsDetailsTileModel>;

export const EditTeamsTile = forwardRef(
	(props: EditTeamsTileProps, ref: Ref<EditTileHandle>): ReactElement => {

		return (
			<EditGenericWithDestinationWindowTile
				{...props}
				requestHandler={updateTeamsTile}
				ref={ref}
			/>
		);
	}
);
EditTeamsTile.displayName = "EditTeamsTile";
